import queryKeys from '@/util/hooks/queries/queryKeys';
import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { erpSyncApi } from '../../api/erpSync.api';

/**
 * Pending Approvals Inbox list (PBI #6096). Polled every 60s so the "Supplier Updates"
 * nav badge and the inbox table stay reasonably fresh without a manual refresh.
 * The backend returns 401/403 when the caller holds none of the SupplierUpdateApprove*
 * permissions — that's not transient, so we don't retry it.
 *
 * `enabled` defaults to true (the inbox page always wants the data); the nav bar passes
 * `enabled: hasAnyApprovePermission` so users without any approve permission never fire
 * a request that's guaranteed to 403 on every page load.
 */
export const usePendingApprovalsList = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: [queryKeys.pendingApprovals],
    queryFn: erpSyncApi.queries.getPendingApprovals,
    enabled: options?.enabled ?? true,
    refetchInterval: 60_000,
    retry: (failureCount, error) => {
      const status = isAxiosError(error) ? error.response?.status : undefined;
      if (status === 401 || status === 403) return false;
      return failureCount < 3;
    }
  });
